import {useI18n} from 'store/Store'
import Modal from './Modal'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import {Typography, Box, List, ListItem, styled} from '@mui/material'

const ErrorModal = ({open, onClose, errors = [], title}) => {
    const {i18n} = useI18n()

    const getErrorMessage = (errorCode) => {
        switch (errorCode) {
            case 'GUIDE_HAS_CONNECTED_SESSIONS':
                return i18n.t('guides.deleteErrors.hasConnectedSessions')
            case 'GUIDE_HAS_CONNECTED_DANCES':
                return i18n.t('guides.deleteErrors.hasConnectedDances')
            default:
                return i18n.t('formErrors.somethingWentWrong')
        }
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title || i18n.t('form.delete')}
            buttons={[
                {
                    label: i18n.t('form.ok'),
                    onClick: onClose,
                },
            ]}>
            <ModalContent>
                <ErrorOutlineIcon color="error" sx={{fontSize: 48}} />
                <Typography variant="subtitle1" color="error">
                    {i18n.t('guides.deleteErrors.title')}
                </Typography>
                {errors.length > 0 && (
                    <ErrorList>
                        {errors.map((error, index) => (
                            <ErrorItem key={index}>
                                <Typography variant="body2">
                                    {getErrorMessage(error)}
                                </Typography>
                            </ErrorItem>
                        ))}
                    </ErrorList>
                )}
            </ModalContent>
        </Modal>
    )
}

export default ErrorModal

const ModalContent = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 20px 0;
`

const ErrorList = styled(List)`
    margin: 0;
    padding-left: 20px;
    text-align: left;
`

const ErrorItem = styled(ListItem)`
    padding-bottom: 8px;
`
